import React from 'react';
import styled from 'styled-components';

import { getScreenSize, getThemeColor } from '../../../utils/theme';

const TooltipS = styled.span`
  display: inline-block;
  position: relative;

  &:hover .tooltiptext {
    visibility: visible;
  }
  .tooltiptext {
    visibility: hidden;
    width: 273px;
    background-color: ${getThemeColor(['red'])};
    font-family: 'Lato';
    font-weight: normal;
    line-height: 19px;
    color: ${getThemeColor(['white'])};
    padding: 12px 14px 12px 35px;
    border-radius: 3px;

    position: absolute;
    left: 125%;
    z-index: 1;

    &:before {
      content: ' ';
      display: inline-block;
      position: absolute;
      top: 7px;
      left: -25px;

      border: 10px solid transparent;
      border-right: 15px solid ${getThemeColor(['red'])};
    }

    @media (max-width: ${getScreenSize(['medium'])}) {
      display: none;
    }
  }
`;

export default ({ tooltipText, label }) => (
  <TooltipS>
    {label}
    <span className="tooltiptext">{tooltipText}</span>
  </TooltipS>
);
